import $ from 'jquery';
import { scrollbarWidth } from '@xobotyi/scrollbar-width';

$(':root').css({ '--client-scrollbar-width': `${scrollbarWidth()}px` });
